// Unsubscribe from campaigns, choices and reasons, list and all business lists
export const UNSUBSCRIBE_CHOICE = {
  CHOICE_LIST: 'checkboxList',
  CHOICE_ALL: 'checkboxAll',
}
export const UNSUBSCRIBE_REASON = {
  NO_LONGER_INTERESTED: 'no_longer_interested',
  NEVER_SUBSCRIBED: 'never_subscribed',
  SPAM: 'spam',
}
// TODO: update codebase by using these constants instead of strings
export const STATUS_DRAFT = 'draft'
export const STATUS_SENT = 'sent'
export const STATUS_SCHEDULED = 'scheduled'
export type CampaignStatus =
  | typeof STATUS_DRAFT
  | typeof STATUS_SENT
  | typeof STATUS_SCHEDULED
